import Aura from '@primeuix/themes/aura'
import { definePreset } from '@primeuix/themes'

export const customPreset = definePreset(Aura, {
  components: {
    button: {
      colorScheme: {
        dark: {
          root: {
            secondary: {
              background: '#1212237e',
              hoverBackground: '#121223',
            },
          },
        },
      },
    },
    card: {
      colorScheme: {
        light: {
          root: {
            background: '#fdfefe',
            color: '{surface.700}',
          },
          subtitle: {
            color: '{surface.500}',
          },
        },
      },
      root: {
        borderRadius: '15px',
      },
    },
    paginator: {
      root: {
        background: 'transparent',
      },
    },
    datatable: {
      row: {
        background: 'transparent',
      },
      header: {
        background: 'transparent',
      },
      paginatorBottom: {
        borderWidth: '0',
      },
      colorScheme: {
        light: {
          row: {
            hoverBackground: 'rgba(0,0,0,0.2)',
            hoverColor: '#fff',
          },
        },
      },
    },
    dataview: {
      content: {
        background: 'transparent',
      },
    },
    panel: {
      root: {
        background: 'transparent',
      },
    },
    multiselect: {
      root: {
        background: 'transparent',
      },
    },
    select: {
      root: {
        background: 'transparent',
      },
    },
    badge: {
      colorScheme: {
        dark: {
          success: {
            background: 'rgba(25, 135, 84, 0.8)',
            color: '#ffffff',
          },
          danger: {
            background: 'rgba(220, 53, 69, 0.8)',
            color: '#ffffff',
          },
          info: {
            background: 'rgba(113, 110, 253, 0.8)',
            color: '#ffffff',
          },
        },
      },
    },
    tabs: {
      tabpanel: {
        background: 'transparent',
      },
      tablist: {
        background: 'transparent',
      },
      navButton: {
        background: 'transparent',
      },
    },
    fieldset: {
      root: {
        background: 'transparent',
      },
      legend: {
        background: 'transparent',
      },
    },
  },
  semantic: {
    colorScheme: {
      light: {
        primary: {
          50: '{gray.50}',
          100: '{gray.100}',
          200: '{gray.200}',
          300: '{gray.300}',
          400: '{gray.400}',
          500: '{gray.500}',
          600: '{gray.600}',
          700: '{gray.700}',
          800: '{gray.800}',
          900: '{gray.900}',
        },
        surface: {
          0: '#f8fafc',
          50: '#f8fafc',
        },
        success: {},
        content: {
          background: '#f8fafc', // same value (optional duplicate)
        },
      },
      dark: {
        primary: {
          50: '{gray.50}',
          100: '{gray.100}',
          200: '{gray.200}',
          300: '{gray.300}',
          400: '{gray.400}',
          500: '{gray.500}',
          600: '{gray.600}',
          700: '{gray.700}',
          800: '{gray.800}',
          900: '{gray.900}',
        },
        surface: {
          0: '#16162a',
          50: '#16162a',
          700: '#dededeff',
          800: '#5151512b',
        },
        content: {
          background: '#f8fafc', // same value (optional duplicate)
        },
      },
    },
  },
})
